import React from 'react';
import { Unplug } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../Card';
export function NotConnected() {
  return <Card className="mt-4" data-id="element-274" data-mp="3l149du6lmfw0">
      <CardHeader data-id="element-275" data-mp="2tompxesdvj2">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary text-secondary-foreground" data-id="element-276" data-mp="2s3pu15020i1">
          <Unplug className="h-4 w-4" aria-hidden="true" data-id="element-277" data-mp="3tzzlfmwbqk78" />
        </span>
        <CardTitle className="mt-3" data-id="element-278" data-mp="36ax46g5lqtd9">No data source connected</CardTitle>
        <CardDescription data-id="element-279" data-mp="31b2dodpqo5sq">
          This dashboard only displays measured traffic. There is no sample or placeholder data.
        </CardDescription>
      </CardHeader>
      <CardContent data-id="element-280" data-mp="3g1rp9h743mx4">
        <ol className="list-decimal space-y-1.5 pl-5 text-sm text-muted-foreground" data-id="element-281" data-mp="3b8ynn26xwup9">
          <li data-id="element-282" data-mp="3b75dve115ud1">Run supabase/schema.sql in the Supabase SQL editor.</li>
          <li data-id="element-283" data-mp="2nht5ggdj1qbs">Add the project URL and anon key to data/supabaseConfig.ts.</li>
          <li data-id="element-284" data-mp="2ij9jwh2uigjy">Deploy the maintenance page so it starts recording events.</li>
        </ol>
      </CardContent>
    </Card>;
}